<div class="container">
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
      <div class="card card-signin my-5">
        <div class="card-body">
          <h5 class="card-title text-center">{{'recover-password.title' | translate}}</h5>
          <form (ngSubmit)="onRecover(f)" #f="ngForm">
            <div class="form-group">
              <label for="email">{{'recover-password.email' | translate}}</label>
              <input type="email" id="email" name="email" ngModel class="form-control">
            </div>
            <div class="text-center">
              <button class="btn btn-primary btn-signin" type="submit">{{'recover-password.submit' | translate}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
